module.exports = __webpack_public_path__ + "img/21.4fb01564.png";